import { UtilService } from './utils';
import { Listener } from './listener';
import { AppNameText } from '../../enum/appConfig';
function replaceDownloadUrl(url) {
    let urlPath = url.split("/");
    let newDomain = "";
    const $url = window.$url;
    switch (urlPath[2]) {
        case "img.maidiyun.com":
            newDomain = $url.img;
            break;
        case "downs3.maidiyun.com":
            newDomain = $url.downs3;
            break;
        case "pdmapi.maidiyun.com":
            newDomain = $url.pdmapi;
            break;
        case "apicommon.maidiyun.com":
            newDomain = $url.rs;
            break;
    }
    if (!newDomain)
        return url;
    urlPath.splice(0, 3);
    urlPath.unshift(newDomain);
    return urlPath.join("/");
}
const md = {
    //#region 页签相关
    /**
     * 激活对应的面板
     * @param key Setup 设置页
     * @returns
    */
    activeTab(key) {
        if (!key)
            return false;
        return (parent.window || window).md.activeTab(key);
    },
    /**
     * 关闭指定tabId的页签
     * @param tabId 页签的唯一标识
    */
    closeTab(tabId = "") {
        return (parent.window || window).md.closeTab(tabId);
    },
    /**
     * 在主窗口创建或激活指定tabId的页签
     * @param tabId 页签的唯一标识，不传时会自动加guid
     * @param lazyLoad true时只加页签，当激活页签时才会加载内容
     * @param active -1 强制随配置 0随配置 1强制不激活 2强制激活
     */
    openTab(url, title = "", icon = "", tabId = "", notAllowClose = false, width = 0, lazyLoad = false, active = true) {
        return (parent.window || window).md.openTab(url, title, icon, tabId, notAllowClose, active);
    },
    /**
     * 获取当前激活tab的索引
     * @returns
    */
    getTabIndex() {
        return (parent.window || window).md.getTabIndex();
    },
    /**
     * 切换到指定的菜单页
     * @param index 从0开始
     * @param url url地址
     * @returns
     */
    setHome(index, url = '') {
        return window.md.setHome(index, url);
    },
    /**
     * 打开聊天窗口
     * @returns
    */
    openChatTab() {
        return (parent.window || window).md.openChatTab();
    },
    /**
     * 判断聊天窗口是否打开
     * @returns
     */
    chatTabIsOpened() {
        return (parent.window || window).md.chatTabIsOpened();
    },
    //#endregion 页签相关
    //#region 窗口相关
    /**
     * alert
     * @param text
     * @param caption
     * @returns
     */
    alert(text, caption) {
        return (window || parent.window).md.alert(text, caption);
    },
    /**
     * 抖动窗口
     */
    shake() {
        return (window || parent.window).md.shake();
    },
    /**
     * 获取当前窗口的状态
     * @returns Normal = 0,Minimized = 1,Maximized = 2
    */
    getWindowState() {
        return (parent.window || window).md.getWindowState();
    },
    /**
    * 截屏
    * @param {Function} callback
    */
    screenshot(callback, isHideWindow = false) {
        const screenshot = (window || window).md.screenshot;
        if (screenshot) {
            screenshot(UtilService.RegisterWinFunc(callback), isHideWindow);
        }
        else {
            console.error("底座暂未实现截图功能");
        }
    },
    /**
     * 打开弹出窗口
     * @param callback 打开窗口完毕后的回调，js的function名称
     * @param isBackground 是否后台静默打开
    */
    openWindow(url, width, height, callback, loadingImage = null, isModal = false, resizeMode = 2, isBackground = false) {
        return (parent.window || window).md.openWindow(url, width, height, callback, loadingImage, isModal, resizeMode, isBackground);
    },
    /**
     * 显示窗口
     * @param url
     * @param width
     * @param height
     * @param isModal
     * @returns
     */
    showWindow(url, width = 0, height = 0, isModal = false) {
        return (parent.window || window).md.showWindow(url, width, height, isModal);
    },
    /**
    * 后台静默创建一个隐藏窗口，且不会展示
    */
    initWindow(url, title, width, height) {
        return (parent.window || window).md.initWindow(url, title, width, height);
    },
    /**
     * 在外部浏览器中打开url地址
     * @param url
    */
    openUrl(url) {
        return (parent.window || window).md.openUrl(url);
    },
    //#endregion 窗口相关
    //#region 文件、文件夹操作
    /**
     * 打开文件选择窗口
     * failed失败；其他为文件全路径
    */
    openFileDlg(multi = false, filter = "", defaultPath = "") {
        return (parent.window || window).md.openFileDlg(multi, filter, defaultPath);
    },
    /**
     * 打开目录选择窗口
     * 返回：failed失败；其他为目录路径
    */
    openDirectoryDlg(defaultPath = "") {
        return (parent.window || window).md.openDirectoryDlg(defaultPath);
    },
    /**
     *打开文件夹
     * failed失败；
    */
    openDirectory(directory = "") {
        return (parent.window || window).md.openDirectory(directory);
    },
    /**
     * 创建文件夹
     * @param directory
     * @returns
     */
    createDirectories(directory) {
        return (parent.window || window).md.createDirectories(directory);
    },
    /**
     * 删除文件夹
     * @param directory
     * @param recursive
     * @returns
     */
    deleteDirectory(directory, recursive = true) {
        return (parent.window || window).md.deleteDirectory(directory, recursive);
    },
    /**
     *保存文件窗口
     * failed失败；其他为文件全路径
    */
    saveFileDlg(filter = "", defaultPath = "", fileName = "") {
        return (parent.window || window).md.saveFileDlg(filter, defaultPath, fileName);
    },
    /**
     *打开文件
     * failed失败；
    */
    openFile(directory = "") {
        return (parent.window || window).md.openFile(directory);
    },
    /**
     *检测文件是否存在
     * failed失败；其他为是否存在的布尔值
    */
    existFile(filePath = "") {
        return (parent.window || window).md.existFile(filePath);
    },
    /**
    * 解压文件
    * @param filePath 要解压的文件路径
    * @param dirPath  解压到的文件夹路径
    * @param password 解压的文件密码
    * @param isDelFile 解压完成是否删除文件
    */
    extractZip(filePath = "", dirPath = "", password = "", isDelFile = true) {
        return (window || window).md.extractZip(filePath, dirPath, password, isDelFile);
    },
    /**
     *  获取文件Hash
     *  入参支持相对路径
    */
    getFileHash(directory = "") {
        return (parent.window || window).md.getFileHash(directory);
    },
    /**
     * 获取文件的base64
     * @param {string} path
     * @returns {string}
    */
    getImgBase64(path) {
        return (window || window).md.getImgBase64(path);
    },
    /**
     * 获取文件大小
     * @param {string} path
     * @returns {number}
    */
    getFileSize(path) {
        return parseInt(window.md.getFileSize(path));
    },
    /**
     *  获取文件版本号
     *  @params filepath  文件路径
    */
    getFileVer(filePath) {
        return (window || window).md.getFileVer(filePath) || "";
    },
    /**
     *  获取本地文件信息(含本地库信息)
     *  入参支持相对路径
    */
    getFileInfos(files, categoryId = 110, useFileThumb = false) {
        let obj = (window || window).localfile.hasOwnProperty("getFileInfos") ? (window || window).localfile : (window || window).md;
        let infos = obj.getFileInfos(JSON.stringify(files), categoryId, useFileThumb);
        return infos === "failed" ? [] : JSON.parse(infos);
    },
    /**
     *  获取本地文件信息
     *  入参支持相对路径
    */
    getFileInfo(filePath = "") {
        let fileJson = (parent.window || window).md.getFileInfo(filePath);
        return fileJson ? JSON.parse(fileJson) : "";
    },
    /**
     * 根据路径复制文件
     * @param filePaths
     * @returns
     */
    copyFiles(filePaths) {
        return (window || window).md.copyFiles(filePaths);
    },
    /**
     *
     * @param originPath 原位置
     * @param aimPath  目标位置
    */
    copyFileTo(originPath, aimPath) {
        return (window || window).md.copyFileTo(originPath, aimPath);
    },
    //#endregion 文件、文件夹
    //#region 下载文件
    /**
     *取消下载
     * 没有返回值  会进入下载进度的函数中
     * deleteTempFile 是否删除临时文件 默认不删除
    */
    cancelDownload(downloadId = "", deleteTempFile = false) {
        (parent.window || window).md.cancelDownload(downloadId, deleteTempFile);
    },
    /**
    *取消下载 (下载改版 暂时使用 系统自带   )
    * 没有返回值  会进入下载进度的函数中
    * deleteTempFile 是否删除临时文件 默认不删除
    */
    cancelDownload2(downloadId = "", deleteTempFile = false) {
        (window || window).md.cancelDownload2(downloadId, deleteTempFile);
    },
    /**
     * 下载文件   下载改版   暂时增加download2
     * @param progress (参数：downloadId,进<1-100>,速度<字节>,状态值,状态描述)：下载进度回调，js的function方法
     * @param downloadId 下载任务唯一编号，一般不传，但是对于已经在下载队列中的，可以将队列的downloadId直接传入
     * 下载任务的唯一编号
    */
    download2(url, filepath, downloadId = "", progress, isThunderRetry = false) {
        url = replaceDownloadUrl(url);
        url.startsWith("//") && (url = location.protocol + url);
        return (window || window).md.download2(url, filepath, UtilService.RegisterWinFunc(progress), downloadId, isThunderRetry);
    },
    /**
     *暂停下载
     * 没有返回值  会进入下载进度的函数中
    */
    pauseDownload(downloadId = "") {
        (parent.window || window).md.pauseDownload(downloadId);
    },
    //#endregion 下载文件
    //#region 上传文件
    /**
     * 取消上传文件
    */
    cancelUpload(uploadId = "") {
        (parent.window || window).md.cancelUpload(uploadId);
    },
    /**
     * 上传文件
     * @params filePath文件物理路径
     * @params progress 上传的回调 会返回进度 返回参数和下载返回的参数一致
     *
    */
    upload(filePath, signatureStr = {}, uploadId, progress) {
        const funcName = UtilService.RegisterWinFunc(progress);
        const contentType = UtilService.ContentType(UtilService.FileExtension(filePath));
        // string url
        // string filePath,
        // string method = "PUT"
        // string contentType = "application/octet-stream"
        // string progress = null
        // string uploadId = null
        // string token = null
        return (window || window).md.upload(filePath, JSON.stringify(signatureStr), contentType, funcName, uploadId);
    },
    //#endregion 上传文件
    //#region 拖拽/剪切板文件
    /**
     * 剪切板文案内容设置
     * @param str
     * @returns
     */
    setClipboardCusData(str) {
        return (window || parent.window).md.setClipboardCusData(str);
    },
    getClipboardCusData() {
        return (window || parent.window).md.getClipboardCusData();
    },
    /**
     * 清空剪切板
     * @returns
     */
    clearClipboard() {
        return (window || parent.window).md.clearClipboard();
    },
    /**
     * 获取剪切板图片
     * @returns
     */
    getClipboardImg() {
        return (window || window).md.getClipboardImg();
    },
    /**
     * 获取剪切板复制的文件路径
     * @returns
    */
    getClipboardFiles() {
        return JSON.parse(window.md.getClipboardFiles()).filter((_file) => _file.FileType === 1);
    },
    /**
     * 返回拖拽文件路径
     * @returns
    */
    getDragFiles() {
        let files = (parent.window || window).md.getDragFiles();
        return JSON.parse(files).filter((_file) => _file.FileType === 1 || _file.FileType === 2);
    },
    //#endregion 拖拽/剪切板文件
    //#region 用户
    reLogin() {
        (window || parent.window).md.reLogin();
    },
    getLoginInfo() {
        return (window || parent.window).md.getLoginInfo();
    },
    /**
     * 切换用户重新登录
     * @param userID
     * @param userName
     * @returns
     */
    swichUsers(userID, userName) {
        return (window || parent.window).md.swichUsers(userID, userName);
    },
    /**
     * 重置或刷新指定数据，目前仅支持refreshUnreadCount；刷新未读消息数
     * @param event refreshUnreadCount；刷新未读消息数，refreshLoginInfo更新用户信息
     * @param arg
     * @returns
     */
    refresh(event, arg) {
        return (window || parent.window).md.refresh(event, arg);
    },
    //#endregion 用户
    //#region 应用程序
    /**获取应用程序名称 */
    getAppName() {
        let appName = '';
        try {
            appName = (window || parent.window).md.getAppName();
        }
        catch (error) { }
        return appName;
    },
    /**应用程序名称label */
    getAppNameLabel() {
        const appName = this.getAppName();
        return AppNameText[appName] || null;
    },
    getAppVersion() {
        return (window || parent.window).md.getAppVersion();
    },
    getAppPath() {
        return (window || parent.window).md.getAppPath();
    },
    getSysTime() {
        return (window || parent.window).md.getSysTime();
    },
    restart() {
        (window || parent.window).md.restart();
    },
    /**
     * 设置系统时间
     * @param dateTimeStr
     * @returns
     */
    setSysTime(dateTimeStr) {
        if ((window || window).md.setSysTime)
            return (window || window).md.setSysTime(dateTimeStr);
    },
    /**
     * 设置浏览器代理
     * @param proxy
     */
    setProxy(proxy) {
        (window || parent.window).md.setProxy(proxy);
    },
    /**
     * 设置浏览器代理(解密)
     * @param encryptProxy
     */
    setProxyDecrpty(encryptProxy) {
        (window || parent.window).md.setProxyDecrpty(encryptProxy);
    },
    /**
     * 跨页监听事件
    */
    $on(eventName, event) {
        Listener.add(eventName, (args) => {
            try {
                args = JSON.parse(args);
                event(args);
            }
            catch (e) {
                event(args);
            }
        });
        (parent.window || window).md.onListen(eventName);
    },
    /**
     * 跨页触发事件
    */
    $emit(event, args = "", self = true) {
        if (self) {
            const fn = (parent.window || window)[event];
            fn && fn(JSON.stringify(args));
        }
        (parent.window || window).md.emit(event, JSON.stringify(args));
    },
    /**
     * 移除事件监听
     * @param event
     */
    $remove(event) {
        (parent.window || window).md.remove(event);
    },
    /**
    * 获取应用程序安装 磁盘 格式   D:
    */
    getAppPath_Disk() {
        let appPath = (parent.window || window).md.getAppPath();
        return appPath.substr(0, 2);
    },
    /**
     * 获取应用接口配置
     * @returns
     */
    getApiConfig() {
        let config = {};
        try {
            config = JSON.parse((window || parent.window).md.getApiConfig());
        }
        catch (error) {
            config = {};
        }
        return config;
    },
    //#endregion 应用程序
    //#region 工具函数
    /**
     *  获取字符串的MD5  基座获取和前端服务获取的不一致 两方共用的 md5 使用基座的方法获取
     *  入参支持相对路径
    */
    getMD5Hash(string = "") {
        return (parent.window || window).md.getMD5Hash(string);
    },
    //#endregion 工具函数
};
export default md;
